Array of candidate profile summaries.
